import { BeekeeperIcon } from './BeekeeperIcon';

/**
 * author: guenth39
 * id 520FBDF0-4EB1-4413-89F9-AB4E3518FA38
 * name beekeeper
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/beekeeper.svg
 * tags
 * - Nature 
 * - Agriculture 
 */
export const ApiaristsIcon = BeekeeperIcon;
export default ApiaristsIcon